var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"ant-breadcrumb",attrs:{"tag":"div","name":"breadcrumb"}},_vm._l((_vm.breadCrumb),function(i){return _c('a-breadcrumb-item',{key:i.id},[(i.path)?_c('router-link',{attrs:{"to":i.path}},[_vm._v(_vm._s(i.title))]):_c('span',[_vm._v(_vm._s(i.title))])],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }